import React from 'react';
import PropTypes from 'prop-types';

const withValidateOnChangeHOCGenerator = (Component) => {
  function WithValidateOnChangeHOC(props) {
    const { values, inputValue, multiInputValidateOnChange, setValidationMessage, resetValidationMessage } = props;

    const validateOnChange = () => {
      if (multiInputValidateOnChange) {
        const { isValid, validationMessage } = multiInputValidateOnChange(inputValue, values);

        resetValidationMessage();
        if (!isValid) {
          setValidationMessage(validationMessage);
        }
      }
    };

    return <Component {...props} validateOnChange={validateOnChange} />;
  }

  WithValidateOnChangeHOC.propTypes = {
    values: PropTypes.array,
    inputValue: PropTypes.string,
    multiInputValidateOnChange: PropTypes.func,
    setValidationMessage: PropTypes.func,
    resetValidationMessage: PropTypes.func,
  };

  return WithValidateOnChangeHOC;
};

const withValidateOnChange = () => (Component) => withValidateOnChangeHOCGenerator(Component);

export default withValidateOnChange;
